export default __webpack_public_path__ + "static/media/network3.0b82e59d.svg";